var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CategoryMenu } from '.';
import { CategoryLinkList } from './CategoryLinkList';
import { DELAYS } from '../../../fadeInAnimation';
var formatColumnProps = function (columnData) {
    var _a, _b;
    return {
        eyebrow: (columnData === null || columnData === void 0 ? void 0 : columnData.fields.eyebrow) || '',
        categoryLink: ((_a = columnData === null || columnData === void 0 ? void 0 : columnData.fields.categoryLink) === null || _a === void 0 ? void 0 : _a.fields)
            ? {
                label: columnData.fields.categoryLink.fields.label,
                href: columnData.fields.categoryLink.fields.href,
                openInNewTab: columnData.fields.categoryLink.fields.openInNewTab,
                trackingLabel: columnData.fields.categoryLink.fields.trackingLabel,
                svgIcon: columnData.fields.categoryLink.fields.icon
            }
            : { label: '', href: '', trackingLabel: '' },
        subLinks: ((_b = columnData === null || columnData === void 0 ? void 0 : columnData.fields.subLinks) === null || _b === void 0 ? void 0 : _b.map(function (link) { return ({
            label: (link === null || link === void 0 ? void 0 : link.fields.label) || '',
            href: (link === null || link === void 0 ? void 0 : link.fields.href) || '',
            openInNewTab: (link === null || link === void 0 ? void 0 : link.fields.openInNewTab) || false,
            trackingLabel: (link === null || link === void 0 ? void 0 : link.fields.trackingLabel) || '',
            svgIcon: (link === null || link === void 0 ? void 0 : link.fields.icon) || ''
        }); })) || []
    };
};
export var ContentfulCategoryMenu = function (_a) {
    var activeItem = _a.activeItem, _b = _a.onNavigate, onNavigate = _b === void 0 ? function () { } : _b;
    return (React.createElement(CategoryMenu, { column1: React.createElement(CategoryLinkList, __assign({}, formatColumnProps(activeItem.fields.column1), { delay: DELAYS[1], onNavigate: onNavigate })), column2: React.createElement(CategoryLinkList, __assign({}, formatColumnProps(activeItem.fields.column2), { delay: DELAYS[2], onNavigate: onNavigate })), column3: React.createElement(CategoryLinkList, __assign({}, formatColumnProps(activeItem.fields.column3), { delay: DELAYS[3], onNavigate: onNavigate })), column4: React.createElement(CategoryLinkList, __assign({}, formatColumnProps(activeItem.fields.column4), { delay: DELAYS[4], onNavigate: onNavigate })) }));
};
